// Flow Builder Mock Data
import {
  DataFlow,
  FlowNode,
  FlowConnection,
  Connection
} from "./models/data-integration.model";

export const mockConnections: Connection[] = [
  {
    id: "conn-1",
    name: "Production Snowflake",
    dataSourceType: "snowflake",
    status: "active",
    config: {
      host: "company.snowflakecomputing.com",
      database: "PROD_DB",
      warehouse: "COMPUTE_WH"
    },
    createdAt: "2024-11-15T10:30:00Z",
    lastUsed: "2024-11-19T14:22:00Z"
  }
  //   {
  //     id: "conn-2",
  //     name: "Analytics PostgreSQL",
  //     dataSourceType: "postgres",
  //     status: "active",
  //     config: {
  //       host: "analytics-db.company.com",
  //       port: "5432",
  //       database: "analytics"
  //     },
  //     createdAt: "2024-11-10T09:15:00Z",
  //     lastUsed: "2024-11-19T11:45:00Z"
  //   },
  //   {
  //     id: "conn-3",
  //     name: "Data Lake S3",
  //     dataSourceType: "s3",
  //     status: "active",
  //     config: {
  //       bucket: "company-data-lake",
  //       region: "us-east-1",
  //       prefix: "raw-data/"
  //     },
  //     createdAt: "2024-11-12T16:20:00Z"
  //   }
];

export const mockFlowNodes: FlowNode[] = [
  {
    id: "node-1",
    type: "source",
    label: "Snowflake Source",
    connectionId: "conn-1",
    position: { x: 100, y: 150 },
    config: {
      table: "CUSTOMER_DATA",
      query: "SELECT * FROM CUSTOMER_DATA WHERE updated_at > ?"
    }
  },
  {
    id: "node-2",
    type: "transform",
    label: "Data Cleansing",
    position: { x: 350, y: 150 },
    config: {
      transformations: ["remove_nulls", "normalize_emails", "validate_phone"]
    }
  },
  {
    id: "node-3",
    type: "destination",
    label: "Analytics DB",
    connectionId: "conn-2",
    position: { x: 600, y: 150 },
    config: {
      table: "clean_customers",
      writeMode: "upsert"
    }
  }
];

export const mockFlowConnections: FlowConnection[] = [
  {
    id: "flow-conn-1",
    sourceId: "node-1",
    targetId: "node-2",
    label: "Raw Data"
  },
  {
    id: "flow-conn-2",
    sourceId: "node-2",
    targetId: "node-3",
    label: "Cleaned Data"
  }
];

export const mockDataFlows: DataFlow[] = [
  {
    id: "flow-1",
    name: "Customer Data Pipeline",
    description:
      "ETL pipeline for customer data from Snowflake to Analytics DB",
    nodes: mockFlowNodes,
    connections: mockFlowConnections,
    status: "active",
    createdAt: "2024-11-15T10:30:00Z",
    lastRun: "2024-11-19T06:00:00Z"
  },
  {
    id: "flow-2",
    name: "Sales Data Sync",
    description: "Real-time sync of sales data",
    nodes: [],
    connections: [],
    status: "draft",
    createdAt: "2024-11-18T14:15:00Z"
  },
  {
    id: "flow-3",
    name: "IoT Sensor Pipeline",
    description: "Stream processing for IoT sensor data",
    nodes: [],
    connections: [],
    status: "paused",
    createdAt: "2024-11-10T08:45:00Z",
    lastRun: "2024-11-17T12:30:00Z"
  }
];
